// extracted by mini-css-extract-plugin
export default {"townPage":"TownPage_townPage__pGdIl","breadcrumbs":"TownPage_breadcrumbs__Gd1wC","info":"TownPage_info__ibqNV","tabs":"TownPage_tabs__Ohdq1","clear":"TownPage_clear__FKoP9"};